/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AccountCsvData,
    AccountCsvDataFromJSON,
    AccountCsvDataToJSON,
} from '../models/AccountCsvData';
import {
    type AccountData,
    AccountDataFromJSON,
    AccountDataToJSON,
} from '../models/AccountData';
import {
    type AccountDataSnapshot,
    AccountDataSnapshotFromJSON,
    AccountDataSnapshotToJSON,
} from '../models/AccountDataSnapshot';
import {
    type AccountDataVersion,
    AccountDataVersionFromJSON,
    AccountDataVersionToJSON,
} from '../models/AccountDataVersion';
import {
    type AccountImportList,
    AccountImportListFromJSON,
    AccountImportListToJSON,
} from '../models/AccountImportList';

export interface DeleteAccountRequest {
    id: string;
}

export interface GetAccountRequest {
    id: string;
}

export interface GetAccountHistoryRequest {
    id: string;
    from?: Date;
}

export interface GetAccountSnapshotsRequest {
    id: string;
    from?: Date;
}

export interface ImportAccountsRequest {
    portfolioId: string;
    accountImportList: AccountImportList;
}

export interface UpdateAccountRequest {
    id: string;
    accountData: AccountData;
}

export interface UploadAccountsRequest {
    portfolioId: string;
    accountCsvData: Array<AccountCsvData>;
    createSegment?: boolean;
}

/**
 * 
 */
export class AccountApi extends runtime.BaseAPI {

    /**
     * Creates request options for deleteAccount without sending the request
     */
    async deleteAccountRequestOpts(requestParameters: DeleteAccountRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/account/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteAccountRaw(requestParameters: DeleteAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAccount(requestParameters: DeleteAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAccountRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAccount without sending the request
     */
    async getAccountRequestOpts(requestParameters: GetAccountRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/account/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAccountRaw(requestParameters: GetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountData>> {
        const requestOptions = await this.getAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountDataFromJSON(jsonValue));
    }

    /**
     */
    async getAccount(requestParameters: GetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountData> {
        const response = await this.getAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAccountHistory without sending the request
     */
    async getAccountHistoryRequestOpts(requestParameters: GetAccountHistoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAccountHistory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['from'] != null) {
            queryParameters['from'] = (requestParameters['from'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/account/{id}/history`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAccountHistoryRaw(requestParameters: GetAccountHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountDataVersion>> {
        const requestOptions = await this.getAccountHistoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountDataVersionFromJSON(jsonValue));
    }

    /**
     */
    async getAccountHistory(requestParameters: GetAccountHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountDataVersion> {
        const response = await this.getAccountHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAccountSnapshots without sending the request
     */
    async getAccountSnapshotsRequestOpts(requestParameters: GetAccountSnapshotsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAccountSnapshots().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['from'] != null) {
            queryParameters['from'] = (requestParameters['from'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/account/{id}/snapshots`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAccountSnapshotsRaw(requestParameters: GetAccountSnapshotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccountDataSnapshot>>> {
        const requestOptions = await this.getAccountSnapshotsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccountDataSnapshotFromJSON));
    }

    /**
     */
    async getAccountSnapshots(requestParameters: GetAccountSnapshotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccountDataSnapshot>> {
        const response = await this.getAccountSnapshotsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importAccounts without sending the request
     */
    async importAccountsRequestOpts(requestParameters: ImportAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['portfolioId'] == null) {
            throw new runtime.RequiredError(
                'portfolioId',
                'Required parameter "portfolioId" was null or undefined when calling importAccounts().'
            );
        }

        if (requestParameters['accountImportList'] == null) {
            throw new runtime.RequiredError(
                'accountImportList',
                'Required parameter "accountImportList" was null or undefined when calling importAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/account/import/{portfolioId}`;
        urlPath = urlPath.replace('{portfolioId}', encodeURIComponent(String(requestParameters['portfolioId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccountImportListToJSON(requestParameters['accountImportList']),
        };
    }

    /**
     */
    async importAccountsRaw(requestParameters: ImportAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: number; }>> {
        const requestOptions = await this.importAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async importAccounts(requestParameters: ImportAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: number; }> {
        const response = await this.importAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateAccount without sending the request
     */
    async updateAccountRequestOpts(requestParameters: UpdateAccountRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAccount().'
            );
        }

        if (requestParameters['accountData'] == null) {
            throw new runtime.RequiredError(
                'accountData',
                'Required parameter "accountData" was null or undefined when calling updateAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/account/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AccountDataToJSON(requestParameters['accountData']),
        };
    }

    /**
     */
    async updateAccountRaw(requestParameters: UpdateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountData>> {
        const requestOptions = await this.updateAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountDataFromJSON(jsonValue));
    }

    /**
     */
    async updateAccount(requestParameters: UpdateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountData> {
        const response = await this.updateAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uploadAccounts without sending the request
     */
    async uploadAccountsRequestOpts(requestParameters: UploadAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['portfolioId'] == null) {
            throw new runtime.RequiredError(
                'portfolioId',
                'Required parameter "portfolioId" was null or undefined when calling uploadAccounts().'
            );
        }

        if (requestParameters['accountCsvData'] == null) {
            throw new runtime.RequiredError(
                'accountCsvData',
                'Required parameter "accountCsvData" was null or undefined when calling uploadAccounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['createSegment'] != null) {
            queryParameters['createSegment'] = requestParameters['createSegment'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/account/upload/{portfolioId}`;
        urlPath = urlPath.replace('{portfolioId}', encodeURIComponent(String(requestParameters['portfolioId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['accountCsvData']!.map(AccountCsvDataToJSON),
        };
    }

    /**
     */
    async uploadAccountsRaw(requestParameters: UploadAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: number; }>> {
        const requestOptions = await this.uploadAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async uploadAccounts(requestParameters: UploadAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: number; }> {
        const response = await this.uploadAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
